import MetalsStorage from "../storage/metals-storage";
import { console } from "../utils/functions";

export default function reducer(state = new MetalsStorage({}), action) {
  switch (action.type) {
    case "METALS_SET_DATA": {
      let newState = new MetalsStorage({ ...state });
      newState.setAll(action.payload.basedata);
      newState.setAvailable(action.payload.listeEdelmetall, action.payload.timeStampEdelmetallLieferung);
      return newState;
    }
    case "METALS_SET_LIST_DATA": {
      let newState = new MetalsStorage({ ...state });
      newState.setAvailable(action.payload.listeEdelmetall, action.payload.timeStampEdelmetallLieferung);
      return newState;
    }
    case "METALS_SET_BASE_DATA": {
      let newState = new MetalsStorage({ ...state });
      newState.setAll(action.payload.basedata);
      return newState;
    }
    case "METALS_RESET_DATA": {
      console.log("METALS_RESET_DATA")
      let newState = new MetalsStorage({ ...state });
      return newState;
    }
    default: return state;
  }
}
